import { createSlice } from "@reduxjs/toolkit";

const getTime = () => {
  var d = new Date();
  return d.getTime();
}

export const questionSlice = createSlice({
  name: "question",
  initialState: {
    value: [],
    title : "",
    currentQuestion: 1 ,
    startTime: getTime(),
    occupiedTopics : [],
    allTopics: [],
    completedPapers : [],
    score : [0,0,0],
  },

  reducers: {
    setCompletedPapers : (state,action)=>{
      state.completedPapers = action.payload;
    },
    setTitle:(state,action) =>{
      state.title = action.payload;
    },
    setQuestions: (state, action) => {
      // console.log(action.payload);
      state.value = action.payload;
      //   console.error(state.value);
    },
    saveAndNext: (state, action) => {
      let ans = action.payload;
      let currentQ = state.currentQuestion;

      if (state.value[currentQ - 1]) {
        state.value[currentQ - 1].attempted = ans;
        state.value[currentQ - 1].type = ans === "" ? "unanswered" : "answered";
        state.value[currentQ - 1].time +=  getTime() - state.startTime;
        state.currentQuestion =
          state.currentQuestion === state.value.length
            ? 1
            : state.currentQuestion + 1;
        currentQ = state.currentQuestion;
        state.value[currentQ - 1].type = "unanswered";
        state.startTime = getTime();
      }
      //   console.log("next", state.value);
    },
    markAndNext: (state, action) => {
      let ans = action.payload;
      let currentQ = state.currentQuestion;
      if (state.value[currentQ - 1]) {
        state.value[currentQ - 1].attempted = ans;
        state.value[currentQ - 1].type = ans === "" ? "marked" : "ansMarked";
        state.value[currentQ - 1].time += getTime() - state.startTime;

        state.currentQuestion =
          state.currentQuestion === state.value.length
            ? 1
            : state.currentQuestion + 1;
        currentQ = state.currentQuestion;
        state.value[currentQ - 1].type = "unanswered";
        state.startTime = getTime();

      }
      //   console.log("next", state.value);
    },
    incrementQuestion: (state) => {
      let currentQ = state.currentQuestion;
      state.value[currentQ - 1].time += getTime() - state.startTime;
      state.currentQuestion =
        (state.currentQuestion % (state.value.length + 1)) + 1;
        
    let type = state.value[state.currentQuestion - 1].type;
    state.value[state.currentQuestion - 1].type =
      type === "unvisited" ? "unanswered" : type;
        state.startTime = getTime();


    },
    decrementQuestion: (state) => {
      let currentQ = state.currentQuestion;
      state.value[currentQ - 1].time += getTime() - state.startTime;
      state.currentQuestion =
        state.currentQuestion === 1 ? 1 : state.currentQuestion - 1;
      let type = state.value[state.currentQuestion - 1].type;
      state.value[state.currentQuestion - 1].type =
        type === "unvisited" ? "unanswered" : type;
        state.startTime = getTime();

    },
    jumpToQuestion: (state, action) => {
      let currentQ = state.currentQuestion;
        state.value[currentQ - 1].time += getTime() - state.startTime;
      if (action.payload <= state.value.length && action.payload > 0) {
        state.currentQuestion = Number(action.payload);
        let type = state.value[state.currentQuestion - 1].type;
        state.value[state.currentQuestion - 1].type = type === "unvisited" ? "unanswered" :type;
        state.startTime = getTime();
      }
    },
    setOccupiedTopics: (state,action) =>{
      state.occupiedTopics = action.payload;
    },
    setAllTopics:(state,action) =>{
      state.allTopics = action.payload;
    },
    // setScore :(state,action) =>{
    //   state.score = action.payload;
    // }

  },
});

export const {
  setQuestions,
  markAndNext,
  saveAndNext,
  decrementQuestion,
  incrementQuestion,
  jumpToQuestion,
  setOccupiedTopics,
  setAllTopics,
  setTitle,
  setCompletedPapers,
  // setScore,
} = questionSlice.actions;

export const getQuestions = (state) => state.question.value;
export const getCurrentQuestion = (state) => state.question.currentQuestion;
export const getOccupiedTopics = (state) => state.question.occupiedTopics;
export const getAllTopics = (state) => state.question.allTopics;
export const getTitle = (state) => state.question.title;
export const getCompletedPapers = (state) =>state.question.completedPapers;
// export const getScore = (state) => state.question.score;
export default questionSlice.reducer;
